import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import

export default {
	dayCols1_: ({ occuRegnList }, getters, rootState, rootGetters) => {
		let cols = [];

		let mmScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001162')}`, //지역
			prop: 'mmScn',
			fixed: true,
			align: 'left',
			width: '120px',
			sortable: false
		};
		let scn = {
			label: '',
			prop: 'scn',
			fixed: true,
			align: 'left',
			width: '120px',
			sortable: false
		};
		let regnTot = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001730')}`, //Total
			prop: 'regnTot',
			fixed: true,
			align: 'left',
			minWidth: '100px',
			sortable: false
		};

		cols.push(mmScn);
		cols.push(scn);
		cols.push(regnTot);

		let occuRegn = '';

		let propI = 0;

		for (let i = 0; i < occuRegnList.length; i++) {
			let propL = propI + 1;
			let occuLabel = occuRegnList[i].commCdName;

			occuRegn = {
				align: 'left',
				label: occuLabel,
				prop: 'regn' + setLpad(propL, 2, '0'),
				width: '120px',
				sortable: false
			};

			propI++;
			cols.push(occuRegn);
		}

		return cols;
	},

	//바 차트 Label
	stackedLabel_: ({ occuRegnList }, getters, rootState, rootGetters) => {
		let labelArray = [];

		occuRegnList.forEach(row => {
			labelArray.push(row.commCdName);
		});

		return labelArray;
	},

	//바 차트 데이터
	stackedDataSet_: ({ grdList1, occuRegnList }, getters, rootState, rootGetters) => {
		let cols = [];

		let arry = [];
		grdList1.forEach(row => {
			if (row.gubun == 3) {
				arry.push(row);
			}
		});
		if (arry.length > 0) {
			let arryVal = Object.values(arry[0]);
			arryVal.splice(0, 3);
			arryVal.splice(arryVal.length - 4, arryVal.length);

			let arryNum = arryVal.map(i => Number(i));

			let chartData = {
				type: 'bar',
				data: arryNum,
				dataKey: [3],
				backgroundColor: setChartBgColor(1)
			};
			cols.push(chartData);
		}

		return cols;
	},
	dayCols2_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let tgtCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001759')}`, //대상건수
			prop: 'tgtCnt',
			align: 'left',
			minWidth: '50px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001605')}`, //현상명
			prop: 'phmnNm',
			align: 'left',
			minWidth: '200px',
			sortable: false
		};
		let hapCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001760')}`, //발생건수
			prop: 'hapCnt',
			align: 'left',
			minWidth: '120px',
			sortable: false
		};
		let rt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001761')}`, //비율
			prop: 'rt',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};

		cols.push(tgtCnt);
		cols.push(phmnNm);
		cols.push(hapCnt);
		cols.push(rt);

		return cols;
	},
	dayCols3_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let tgtCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001759')}`, //대상건수
			prop: 'tgtCnt',
			align: 'left',
			minWidth: '50px',
			sortable: false
		};
		let dtcCode = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002066')}`, //DTC코드
			prop: 'dtc',
			align: 'left',
			minWidth: '200px',
			sortable: false
		};
		let hapCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001760')}`, //발생건수
			prop: 'hapCnt',
			align: 'left',
			minWidth: '120px',
			sortable: false
		};
		let rt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001761')}`, //비율
			prop: 'rt',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};

		cols.push(tgtCnt);
		cols.push(dtcCode);
		cols.push(hapCnt);
		cols.push(rt);

		return cols;
	},
	dayCols4_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let tgtCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001759')}`, //대상건수
			prop: 'tgtCnt',
			align: 'left',
			minWidth: '50px',
			sortable: false
		};
		let codeNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001181')}`, //사용시간
			prop: 'name',
			align: 'left',
			minWidth: '200px',
			sortable: false
		};
		let hapCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001760')}`, //발생건수
			prop: 'hapCnt',
			align: 'left',
			minWidth: '120px',
			sortable: false
		};
		let rt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001761')}`, //비율
			prop: 'rt',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};

		cols.push(tgtCnt);
		cols.push(codeNm);
		cols.push(hapCnt);
		cols.push(rt);

		return cols;
	},
	dayCols5_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let tgtCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001759')}`, //대상건수
			prop: 'tgtCnt',
			align: 'left',
			minWidth: '50px',
			sortable: false
		};
		let codeNm = {
			label: `${rootGetters['commonStore/getMessage_']('MWCC000972')}`, //주행거리
			prop: 'name',
			align: 'left',
			minWidth: '200px',
			sortable: false
		};
		let hapCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001760')}`, //발생건수
			prop: 'hapCnt',
			align: 'left',
			minWidth: '120px',
			sortable: false
		};
		let rt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001761')}`, //비율
			prop: 'rt',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};

		cols.push(tgtCnt);
		cols.push(codeNm);
		cols.push(hapCnt);
		cols.push(rt);

		return cols;
	},

	chartlcYMaxVal_: state => {
		return Number(state.lcMaxVal);
	},
	chartBcYMaxVal_: state => {
		return Number(state.bcMaxVal);
	}
};
